import React, { useEffect, useState } from 'react'
import { Collapse } from 'antd'

const FooterNavigationLinks = props => {
  const { Panel } = Collapse
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      window.innerWidth > 640 ? setIsMobile(false) : setIsMobile(true)
    }
    window.addEventListener('resize', handleResize)
  })

  return (
    <>
      {isMobile ? (
        <Collapse className="w-full footer-collapse" expandIconPosition="right">
          <Panel header={props.title}>{props.children}</Panel>
        </Collapse>
      ) : (
        <div className="basis-full sm:basis-1/3">
          <p className="text-sans font-semibold text-base">{props.title}</p>
          {props.children}
        </div>
      )}
    </>
  )
}

export default FooterNavigationLinks
